import app from 'app';

app.namespace.Model.RealTimePreviewModel = Backbone.Model.extend({
  '?': 'RealTimePreviewModel',

  log: true,
  devMode: {
    active: false, // dir balak. be careful on this on prod
    timeout: 5000,
  },
  fetchProgress: 0,
  resultData: null,
  postTries: 0,
  getTries: 0,

  stubData: {
    response: 'OK',
    previewResultData: {
      fileName: null,
      posterFilename: null,
      cdnUrl:
        'assetsprod-a.akamaihd.net/urn_publicid_ap_org_f2ca885c9c39417a954a62de7a4354d6_ap_images/29.20449854651163_57.61431686046512.mp4',
      thumbnail: null,
      previewId: Date.now(),
      videoAssetStoryBoard: null,
      startTime: null,
      endTime: null,
    },
    successful: true,
    warning: false,
  },

  statuses: {
    INIT: 'INIT',
    RENDER: 'RENDER',
    POLL: 'POLL',
    WAIT: 'WAIT',
    RETRY: 'RETRY',
    FAIL: 'FAIL',
    ABORT: 'ABORT',
    DONE: 'DONE',
  },

  isAborted: function () {
    return this.get('status') == this.statuses.ABORT;
  },

  isDone: function () {
    return this.get('status') == this.statuses.DONE;
  },

  isFailed: function () {
    return this.get('status') == this.statuses.FAIL;
  },

  isWorking: function () {
    return (
      this.get('status') == this.statuses.INIT ||
      this.get('status') == this.statuses.WAIT ||
      this.get('status') == this.statuses.RENDER ||
      this.get('status') == this.statuses.POLL
    );
  },

  hasParts: function () {
    return this.get('hasParts');
  },

  isRequestingParts: function () {
    return this.get('type') === app.RealtimePreviewType.VIDEO_PARTS;
  },

  defaults: function () {
    return {
      realTimeFetchProgress: 0,
      lastPollTimestamp: null,
      type: app.RealtimePreviewType.VIDEO,
      parts: [],
      hasParts: false,
    };
  },

  initialize: function () {
    this._log('Init');
  },

  abort: function () {
    if (
      this.get('status') != this.statuses.ABORT &&
      this.get('status') != this.statuses.DONE
    ) {
      app.api.renderAsset.ABORT({
        url: this.get('realTimePreviewResultData')
          ? this.get('realTimePreviewResultData').cdnUrl
          : false,
        checksum: this.get('realTimePreviewChecksum'),
        uuid: this.get('visualTrack').metadata.assetUUID,
        previewId: this.get('previewId'),
      });
      if (this.get('previewId')) {
        app.api.realTime.cancelListenRealtimePreview({
          assetUUID: this.get('visualTrack').metadata.assetUUID,
          previewId: this.get('previewId'),
        });
      }
      this._log('<< RTP ABORTED >>');
      this._clearTimers();
      this.set('status', this.statuses.ABORT);
      this.destroy();
    }
  },

  fail: function () {
    this._log('failed');
    this._clearTimers();
    this.set('status', this.statuses.FAIL);
    this.destroy();
  },

  cloneVisualTrack: function () {
    return _.cloneDeepAndClean(this.get('visualTrack'));
  },

  initPreview: function () {
    this.set({
      status: this.statuses.INIT,
      startTime: Date.now(),
    });

    this._progressCounter();
    this.postTries++;
    this.set('status', this.statuses.RENDER);
    if (this.devMode.active) {
      this._postPreviewDone(this.stubData);
      return;
    }
    this._log('Starting POST request');

    const AssetModelProto = app.namespace.Model.AssetModel.prototype;
    const assetModel = AssetModelProto.strip(this.cloneVisualTrack());
    if (
      assetModel.type == app.assetType.FRAGMENT ||
      assetModel.type == app.assetType.SOCIALFRAGMENT
    ) {
      // fragments should always be returned with full volume
      assetModel.volumeControl = {
        video: 1,
        bgMusic: null,
        narration: null,
      };
      assetModel.onVoPlayVolumeControl = {
        video: 1,
        bgMusic: null,
        narration: null,
      };
    }
    assetModel.themeOverrides = this.get('themeOverrides');
    const story = app.storyController.story;
    const storyId = story && story.get && story.get('id');

    const height = this.get('height');
    const params = {
      assetModel,
      storyCustomOverlays: this.get('storyCustomOverlays') || [],
      storyId,
      topicId: this.get('topicId'),
      programmerId: this.get('programmerId'),
      checksum: this.get('realTimePreviewChecksum'),
      aspectRatio: this.get('aspectRatio'),
      themeId: app.rootStore.state.story.themeInfo.themeId,
      RealtimePreviewType: this.get('type'),
    };
    if (height) {
      params.height = height;
    }
    app.api.renderAsset
      .POST(params)
      .done(this._postPreviewDone.bind(this))
      .fail((reason) => {
        this._log(`Failed POST request "${reason?.error}"`);
        this._clearTimers();
        if (!this.isAborted()) {
          this.fail();
        }
      });
  },

  _postPreviewDone: function (response) {
    this._log('Finished POST request');

    this.set({
      previewId: response.previewResultData.previewId,
      realTimePreviewResultData: response.previewResultData,
      status: this.statuses.POLL,
    });

    this._log('Starting socket listening');

    if (this.isRequestingParts()) {
      app.api.realTime
        .listenRealtimePreviewParts({
          assetUUID: this.get('visualTrack').metadata.assetUUID,
          previewId: this.get('previewId'),
        })
        .progress(
          function (response) {
            if (response['0000']) {
              this.set('hasParts', true);
            }
            this.set('parts', response);
          }.bind(this)
        )
        .fail($.noop);
    }

    app.api.realTime
      .listenRealtimePreview({
        assetUUID: this.get('visualTrack').metadata.assetUUID,
        previewId: this.get('previewId'),
      })
      .done(
        function () {
          app.api.realTime.cancelListenRealtimePreview({
            assetUUID: this.get('visualTrack').metadata.assetUUID,
            previewId: this.get('previewId'),
          });
          this._pollGetPreview();
        }.bind(this)
      )
      .progress(
        function () {
          this._pollGetPreview();
        }.bind(this)
      )
      .fail(function () {
        // no fail handling supported yet.
      });
  },

  _pollGetPreview: function () {
    if (this.get('status') == this.statuses.ABORT) {
      return;
    }
    this.getTries++;
    if (this.devMode.active) {
      this._getPreviewTimeout = setTimeout(
        function () {
          this._getPreviewDone(this.stubData);
        }.bind(this),
        this.devMode.timeout
      );
      return;
    }
    app.api.renderAsset
      .GET({
        programmerId: this.get('programmerId'),
        url: this.get('realTimePreviewResultData').cdnUrl,
        checksum: this.get('realTimePreviewChecksum'),
        uuid: this.get('visualTrack').metadata.assetUUID,
        previewId: this.get('previewId'),
      })
      .done(this._getPreviewDone.bind(this))
      .fail(
        function () {
          this.set('lastPollTimestamp', Date.now());
          this.fail();
        }.bind(this)
      );
  },

  _getPreviewDone: function (response) {
    // console.time('_getPreviewDone');
    // var estimated = this._estimateProgressDuration();
    this._log('Finished polling');
    this._clearTimers();

    const seconds = (Date.now() - this.get('startTime')) / 1000;
    this.set({
      realTimePreviewResultData: response.previewResultData,
      status: this.statuses.DONE,
      endTime: Date.now(),
      opDuration: seconds,
    });
    // this._log(
    //     'Done! operation took ' + this.get('opDuration')
    //     + ' seconds, I estimated ' + estimated + ' seconds '
    //     + ((this.get('opDuration') <= estimated) ? ':-) yay.' : ':-( sorry.')
    // );
    if (this.get('type') === app.RealtimePreviewType.STATIC_MASK) {
      app.doctorController.reportStaticPreview(
        this.get('previewId'),
        this.get('visualTrack'),
        seconds
      );
    }
    // console.timeEnd('_getPreviewDone');
  },

  _progressCounter: function () {
    const state = {
      start: Date.now(),
      finish: this._estimateProgressDuration() * 1e3,
    };

    this._loaderInterval = setInterval(
      function () {
        const passedTime = Date.now() - state.start;

        if (passedTime >= state.finish) {
          if (
            this.get('status') !== this.statuses.DONE &&
            this.get('status') !== this.statuses.WAIT
          ) {
            this._log('Changing status to pending');
            this.set('status', this.statuses.WAIT);
            this.set('realTimeFetchProgress', 100);
          }
        } else {
          if (!this.isAborted()) {
            const progress = ~~((passedTime / state.finish) * 100);
            this.set('realTimeFetchProgress', progress);
          }
        }
      }.bind(this),
      1e3
    );
  },

  _estimateProgressDuration: function () {
    const minDuration = 3;
    let rv = minDuration;
    const displayDuration = this.get('visualTrack').displayDuration;
    const speedMap = {
      // amazon viz instance type
      G4: 0.66,
    };
    const speedCoefficient = speedMap.G4;

    if (displayDuration > minDuration) {
      rv = displayDuration / (speedCoefficient * Math.log2(displayDuration));
    }

    return rv;
  },

  _clearTimers: function () {
    if (this._loaderInterval) {
      clearInterval(this._loaderInterval);
    }
    if (this._getPreviewTimeout) {
      clearTimeout(this._getPreviewTimeout);
    }
    if (this._tryPostTimeout) {
      clearTimeout(this._tryPostTimeout);
    }
    this.set('realTimeFetchProgress', 0);
  },

  _log: function (msg) {
    if (this.log) {
      console.log(
        '%cRTPM:: ' + this.get('realTimePreviewChecksum') + ' //',
        'color: #00ABB3',
        this.get('status'),
        msg
      );
    }
  },
});

export default app.namespace.Model.RealTimePreviewModel;
